import { MDText } from 'i18n-react';

import { CellTextAlign } from 'Storybook/core/Datagrid/Datagrid.types';

import bulkBiddingModalTexts from '../BulkBidding.texts';

const LocalT = new MDText(bulkBiddingModalTexts);

export const BULK_BIDDING_DATAGRID_COLUMNS = [
	{
		id: 'vehicleDetails',
		sortable: false,
		text: LocalT.translate('datagrid.vehicleDetails'),
	},
	{
		id: 'reservePrice',
		sortable: false,
		text: LocalT.translate('datagrid.reservePrice'),
		textAlign: CellTextAlign.Center,
	},
	{
		id: 'yourBid',
		sortable: false,
		text: LocalT.translate('datagrid.yourBid'),
		textAlign: CellTextAlign.Center,
	},
];
